import { money, validateEmail } from '../utils/helpers.js'

import { addLineItems } from '../utils/Cart.js'
import { cacheDom } from '../utils/QuerySelectors.js'
import { initGiftCardForm } from '../components/GiftCardForm.js'
import { toggleModal } from '../components/Popup.js'

const dom = {}
const qs = {
  section: 'data-section-type="main-product"',
  images: 'data-product-images',
  price: 'data-product-price',
  form: 'data-product-form',
  sizeSwatchesWrapper: 'data-product-size-swatches',
  thirdSwatchesWrapper: 'data-third-swatches',
  colorSwatchGroupName: 'data-colour-swatch-group-name',
  klarnaPlacement: 'data-key="credit-promotion-auto-size"',
  selectedVariant: 'data-form-variant-id',
  addToCart: 'data-product-addtocart',
  share: 'data-product-share',
  shareUrl: 'data-product-share-url',
  shareMessage: 'data-product-share-msg',
  bisEmail: 'data-product-bis-email',
  bisSubmit: 'data-product-bis-submit',
  bisErrorMsg: 'data-product-bis-error-msg',
  csEmail: 'data-product-cs-email',
  csSubmit: 'data-product-cs-submit',
  csErrorMsg: 'data-product-cs-error-msg',
  // newsletterSubscribe: 'data-product-bis-subscribe',
  popup: 'data-popup',
  activeGarmentTab: 'data-active-garment-tab',
  garmentMobileTrigger: 'data-garment-mobile-trigger',
  preorderText: 'data-preorder-text',
  addons: 'data-section-type="product-addons"',
  relatedProducts: 'data-section-type="related-products"',
  customText: 'data-custom-text',
  oosNotifier: 'data-oos-notifier',
  fisContent: 'data-fis-content',
  fisTrigger: 'data-fis-trigger',
  fisModal: 'data-fis-modal',
  fisProductCard: 'data-fis-product-card',
  fisProductImage: 'data-fis-product-image',
  fisProductTitle: 'data-fis-product-title',
  fisProductPrice: 'data-fis-product-price',
  fisProductOptions: 'data-fis-product-options',
  fisStock: 'data-fis-stock',
  fisStockText: 'data-fis-stock-text',
  fisStores: 'data-fis-stores',
}
const qsAll = {
  colourSwatches: 'data-colour-swatch',
  sizeSwatches: 'data-size-swatch',
  thirdSwatches: 'data-swatch-additional',
  normalSwatches: 'data-swatch',
  lengthSwatches: 'data-length-group',
  cupSwatches: 'data-cup-group',
  garmentTabs: 'data-garment-chart-tab',
  garmentContents: 'data-garment-chart-content',
  colorSwatchGroups: 'data-colour-swatch-group',
  thirdPayButtons: 'data-shopify="payment-button"',
  videos: 'data-pdp-video',
  videoFancyBoxs: 'data-pdp-video-fancybox',
}
const state = {
  section: null,
  currentProduct: null,
  sizeSwatches: [],
  selectedVariant: null,
  swiper: null,
  selectedSizeValue: null,
  selectedThirdValue: null,
  addons: null,
  videos: null,
}

const updateUrls = () => {
  const productUrl = `${state.currentProduct.collectionHandle ? '/collections/' + state.currentProduct.collectionHandle : ''}/products/${state.currentProduct.handle}${state.selectedVariant ? '?variant=' + state.selectedVariant.id : ''}`
  history.pushState({}, '', productUrl)
  dom.shareUrl.value = `${location.origin}${productUrl}`
  return productUrl
}

const updateSelectedVariant = () => {
  const fisContent = state.section.querySelector(`[${qs.fisContent}]`)
  const selectedOptions = Array.from(state.section.querySelectorAll(`.swatch--active[data-swatch-value]`)).map(
    (swatch) => swatch.dataset.swatchValue,
  )
  if (selectedOptions.length == 1 && state.currentProduct.options.length - 1 == selectedOptions.length) {
    state.selectedVariant = state.currentProduct.variants.filter(
      (variant) => variant.options[1] == selectedOptions[0],
    )[0]
    dom.selectedVariant.value = state.selectedVariant.id
    if (isVariantInStock(state.selectedVariant)) {
      fisContent?.classList?.remove('hidden')
    } else {
      fisContent?.classList?.add('hidden')
    }
  } else if (selectedOptions.length == 2 && state.currentProduct.options.length - 1 == selectedOptions.length) {
    state.selectedVariant = state.currentProduct.variants.filter(
      (variant) => selectedOptions.includes(variant.options[1]) && selectedOptions.includes(variant.options[2]),
    )[0]
    dom.selectedVariant.value = state.selectedVariant.id
    if (isVariantInStock(state.selectedVariant)) {
      fisContent?.classList?.remove('hidden')
    } else {
      fisContent?.classList?.add('hidden')
    }
  } else {
    state.selectedVariant = null
    dom.selectedVariant.value = ''
  }
}

const updateSwatches = () => {
  if (state.currentProduct) {
    if ((state.selectedSizeValue || state.selectedThirdValue) && state.currentProduct.options.length > 2) {
      if (state.selectedSizeValue) {
        state.currentProduct.options_by_name[state.currentProduct.options[2]].option.values.forEach((thirdValue) => {
          const variant = state.currentProduct.variants.filter(
            (variant) => variant.options.includes(state.selectedSizeValue) && variant.options.includes(thirdValue),
          )[0]
          const isComingSoon =
            variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.coming_soon === true
          const swatchValue = state.section.querySelector(`[${qsAll.thirdSwatches}][data-swatch-value="${thirdValue}"]`)
          swatchValue?.classList?.toggle('swatch--oos', !variant.available && !isComingSoon)
          swatchValue?.classList?.toggle(
            'swatch--oos__soldout',
            !state.currentProduct.available &&
              (state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS),
          )
        })
      }
      if (state.selectedThirdValue) {
        state.currentProduct.options_by_name.Size.option.values.forEach((sizeValue) => {
          const variant = state.currentProduct.variants.filter(
            (variant) => variant.options.includes(sizeValue) && variant.options.includes(state.selectedThirdValue),
          )[0]
          const isComingSoon =
            variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.coming_soon === true
          const swatchValue = state.section.querySelector(`[data-size-swatch][data-swatch-value="${sizeValue}"]`)
          swatchValue?.classList?.toggle('swatch--oos', !variant.available && !isComingSoon)
          swatchValue?.classList?.toggle(
            'swatch--oos__soldout',
            !state.currentProduct.available &&
              (state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS),
          )
        })
      }
    }

    // Update OOS notifier text for size swatches
    const sizeOosNotifier = dom.sizeSwatchesWrapper
      ? dom.sizeSwatchesWrapper.querySelector(`[${qs.oosNotifier}]`)
      : null
    if (sizeOosNotifier) {
      if (
        state.selectedVariant &&
        state.selectedVariant.metafields &&
        state.selectedVariant.metafields.custom &&
        state.selectedVariant.metafields.custom.coming_soon === true
      ) {
      } else {
      }
    }

    dom.colourSwatches.forEach((colourSwatch) => {
      const productData = JSON.parse(colourSwatch.dataset.colourSwatch) // This is a product object for the color/print

      let isColorComingSoon = false
      // Check if *any* variant of this color/print is coming soon if no size is selected,
      // OR if the specific variant for the selected size is coming soon.
      if (!state.selectedSizeValue) {
        // No size selected yet
        isColorComingSoon = productData.variants.some((v) => v.comingSoon === true)
      } else {
        // A size (and potentially third option) is selected
        const specificVariantForSelectedSize = productData.variants.find(
          (v) =>
            v.options.includes(state.selectedSizeValue) &&
            (state.selectedThirdValue ? v.options.includes(state.selectedThirdValue) : true),
        )
        if (specificVariantForSelectedSize && specificVariantForSelectedSize.comingSoon === true) {
          isColorComingSoon = true
        }
      }

      // Determine if the color swatch should be marked as OOS
      // It's OOS if no variants are available for the current size/third option selection
      const availableVariantsForCurrentSelection = productData.variants
        .filter((variant) => {
          let match = true
          if (state.selectedSizeValue) {
            match = match && variant.options.includes(state.selectedSizeValue)
          }
          if (state.selectedThirdValue) {
            match = match && variant.options.includes(state.selectedThirdValue)
          }
          return match
        })
        .filter((v) => v.available)

      const isOOSForCurrentSelection = availableVariantsForCurrentSelection.length === 0
      console.log('productData', productData, state.selectedVariant)

      // Add 'swatch--oos' if it's OOS AND not 'coming soon' for this specific color/size context
      colourSwatch.classList.toggle('swatch--oos', isOOSForCurrentSelection && !isColorComingSoon)
      if (state.currentProduct.id != colourSwatch.id) {
        colourSwatch.classList.toggle(
          'swatch--oos__soldout',
          !productData.available && (productData.disableBIS == 'true' || productData.disableBIS),
        )
        colourSwatch.classList.toggle(
          'swatch--available',
          state.selectedVariant ? state.selectedVariant.available : productData.available,
        )
      } else {
        colourSwatch.classList.toggle('swatch--available', productData.available)
      }

      // // Toggle the "Sold Out" text label visibility for the *active* color swatch
      // if(colourSwatch.classList.contains('swatch--active')) {
      //   const oosNotifier = colourSwatch.closest('.main-product--option__swatches').querySelector(`[${qs.oosNotifier}]`);
      //   if (oosNotifier) {
      //       const isDisableBIS = state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS;

      //   }
      // }
    })

    // Update and display logic for the sizeOosNotifier
    if (sizeOosNotifier) {
      const isSelectedVariantComingSoon = state.selectedVariant && state.selectedVariant.comingSoon === true
      const isDisableBIS = state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS

      if (isSelectedVariantComingSoon) {
      } else {
        let showOOSForSize = false
        if (state.selectedSizeValue && state.currentProduct) {
          // A size must be selected
          const activeColorName = state.currentProduct.options_by_name.Colour
            ? state.currentProduct.options_by_name.Colour.option.values[0]
            : null
          if (activeColorName) {
            const variantForSelectedSizeAndColor = state.currentProduct.variants.find(
              (v) =>
                v.options.includes(activeColorName) &&
                v.options.includes(state.selectedSizeValue) &&
                (state.selectedThirdValue ? v.options.includes(state.selectedThirdValue) : true),
            )
            if (
              variantForSelectedSizeAndColor &&
              !variantForSelectedSizeAndColor.available &&
              !variantForSelectedSizeAndColor.comingSoon
            ) {
              showOOSForSize = true
            }
          }
        }
      }
    }
  }
}

const updateProduct = () => {
  state.selectedVariant = null

  const productUrl = updateUrls()

  fetch(productUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      // Update Product Images
      dom.images.innerHTML = html.querySelector(`[${qs.images}]`).innerHTML

      // Update Product Price
      dom.price.innerHTML = html.querySelector(`[${qs.price}]`).innerHTML

      // Update Custom Text
      dom.customText.innerHTML = html.querySelector(`[${qs.customText}]`).innerHTML

      state.selectedVariant = state.section.querySelector('.main-product--normal__swatch.swatch--active')
        ? state.currentProduct.variants.filter(
            (variant) =>
              variant.id ==
              parseInt(state.section.querySelector('.main-product--normal__swatch.swatch--active').dataset.swatch),
          )[0]
        : null

      if (state.currentProduct) {
        if (state.currentProduct.options.length == 3 && state.selectedSizeValue && state.selectedThirdValue) {
          state.selectedVariant = state.currentProduct.variants.filter(
            (variant) =>
              variant.options.includes(state.selectedSizeValue) && variant.options.includes(state.selectedThirdValue),
          )[0]
        } else if (state.currentProduct.options.length == 2 && state.selectedSizeValue) {
          state.selectedVariant = state.currentProduct.variants.filter((variant) =>
            variant.options.includes(state.selectedSizeValue),
          )[0]
        }
      }

      // Update product data
      window.productData = state.currentProduct

      // Update Selected Variant ID
      dom.selectedVariant.value = state.selectedVariant?.id || state.currentProduct.defaultVariant

      // Update Size Swatches
      if (dom.sizeSwatchesWrapper)
        dom.sizeSwatchesWrapper.innerHTML = html.querySelector(`[${qs.sizeSwatchesWrapper}]`)?.innerHTML || ''
      if (dom.thirdSwatchesWrapper)
        dom.thirdSwatchesWrapper.innerHTML = html.querySelector(`[${qs.thirdSwatchesWrapper}]`)?.innerHTML || ''
      state.sizeSwatches = Array.from(state.section.querySelectorAll(`[${qsAll.sizeSwatches}]`))
      state.thirdSwatches = Array.from(state.section.querySelectorAll(`[${qsAll.thirdSwatches}]`))

      state.videos = Array.from(state.section.querySelectorAll(`[${qsAll.videos}]`))

      if (state.selectedSizeValue) {
        state.section
          .querySelectorAll(`[${qsAll.sizeSwatches}]`)
          .forEach((sizeSwatch) => sizeSwatch.classList.remove('swatch--active'))
        state.section
          .querySelector(`[${qsAll.sizeSwatches}][data-swatch-value="${state.selectedSizeValue}"]`)
          .classList.add('swatch--active')
      }
      if (state.selectedThirdValue) {
        state.section
          .querySelectorAll(`[${qsAll.thirdSwatches}]`)
          .forEach((thirdSwatch) => thirdSwatch.classList.remove('swatch--active'))
        state.section
          .querySelector(`[${qsAll.thirdSwatches}][data-swatch-value="${state.selectedThirdValue}"]`)
          .classList.add('swatch--active')
      }

      // Init Addons
      if (state.addons) {
        state.addons.innerHTML = html.querySelector(`[${qs.addons}]`)?.innerHTML || ''
        window.setupApiTiles(state.addons)
      }
      // Init Related Products
      if (state.relatedProducts) {
        state.relatedProducts.innerHTML = html.querySelector(`[${qs.relatedProducts}]`)?.innerHTML || ''
        window.initRelatedProducts(state.relatedProducts)
      }
      initSwiper(true)
      initSizeSwatches()
      initThirdSwatches()
      updateSwatches()
      backFormButtonText()
      seeFade()
    })
}

const updateKlarnaStyles = () => {
  setTimeout(() => {
    const klarnaPlacement = state.section.querySelector(`[${qs.klarnaPlacement}]`)
    const style = document.createElement('style')
    style.innerHTML = `.container {border:none !important;padding: 0 !important;font-family: 'Euclid Flex', sans-serif !important;}`
    if (klarnaPlacement && klarnaPlacement.shadowRoot) klarnaPlacement.shadowRoot.appendChild(style)
  }, 2000)
}

const initColourSwatches = () => {
  dom.colourSwatches.forEach((colourSwatch) => {
    colourSwatch.addEventListener('click', () => {
      if (!colourSwatch.classList.contains('swatch--active')) {
        state.currentProduct = JSON.parse(colourSwatch.dataset.colourSwatch)
        dom.colourSwatches.forEach((swatch) => swatch.classList.toggle('swatch--active', colourSwatch == swatch))

        const selectedGroup = colourSwatch?.closest(`[${qsAll.colorSwatchGroups}]`)
        const colourName = state.currentProduct?.options_by_name?.Colour?.option?.values[0]
        dom.colorSwatchGroups.forEach((group) => {
          const groupTitle = group.querySelector(`[${qs.colorSwatchGroupName}]`)
          if (group == selectedGroup) {
            groupTitle.innerHTML = `<span>${groupTitle.getAttribute(qs.colorSwatchGroupName)}</span>${colourName}`
          } else {
            groupTitle.innerHTML = `<span>${groupTitle.getAttribute(qs.colorSwatchGroupName)}</span>`
          }
        })

        updateProduct()
      }
    })
    const colorSwatchGroup = colourSwatch.closest(`[${qsAll.colorSwatchGroups}]`)
    colourSwatch.addEventListener('mouseenter', () => {
      const focusProduct = JSON.parse(colourSwatch.dataset.colourSwatch)
      dom.colorSwatchGroups.forEach((group) => {
        const groupTitle = group.querySelector(`[${qs.colorSwatchGroupName}]`)
        const colourName = focusProduct.options_by_name?.Colour?.option?.values[0]
        if (group == colorSwatchGroup) {
          groupTitle.innerHTML = `<span>${groupTitle.getAttribute(qs.colorSwatchGroupName)}</span>${colourName}`
        }
      })
    })
    colourSwatch.addEventListener('mouseleave', () => {
      const swatchButton = state.section.querySelector(
        `[data-colour-name="${state.currentProduct?.options_by_name?.Colour?.option?.values[0]}"]`,
      )
      const selectedGroup = swatchButton?.closest(`[${qsAll.colorSwatchGroups}]`)
      const colourName = state.currentProduct?.options_by_name?.Colour?.option?.values[0]
      dom.colorSwatchGroups.forEach((group) => {
        const groupTitle = group.querySelector(`[${qs.colorSwatchGroupName}]`)
        if (group == selectedGroup) {
          groupTitle.innerHTML = `<span>${groupTitle.getAttribute(qs.colorSwatchGroupName)}</span>${colourName}`
        } else {
          groupTitle.innerHTML = `<span>${groupTitle.getAttribute(qs.colorSwatchGroupName)}</span>`
        }
      })
    })
  })
}
const initSizeSwatches = () => {
  const searchParams = new URLSearchParams(location.search)
  const sizeParam = searchParams.get('size')
  state.sizeSwatches.forEach((sizeSwatch) => {
    const swatchValue = sizeSwatch.dataset.swatchValue
    sizeSwatch.addEventListener('click', () => {
      state.sizeSwatches.forEach((swatch) => swatch.classList.toggle('swatch--active', sizeSwatch == swatch))
      state.selectedSizeValue = swatchValue

      dom.lengthSwatches.forEach(
        (lengthSwatch) => (lengthSwatch.href = `${lengthSwatch.getAttribute('data-origin-url')}?size=${swatchValue}`),
      )
      dom.cupSwatches.forEach(
        (cupSwatch) => (cupSwatch.href = `${cupSwatch.getAttribute('data-origin-url')}?size=${swatchValue}`),
      )

      updateSelectedVariant()
      backFormButtonText()
      updateUrls()
      updateSwatches()
    })
    if (!!sizeParam && sizeParam == swatchValue) sizeSwatch.dispatchEvent(new Event('click'))
  })
}

const initThirdSwatches = () => {
  state.thirdSwatches.forEach((thirdSwatch) => {
    thirdSwatch.addEventListener('click', () => {
      state.thirdSwatches.forEach((swatch) => swatch.classList.toggle('swatch--active', thirdSwatch == swatch))
      state.selectedThirdValue = thirdSwatch.dataset.swatchValue

      updateSelectedVariant()
      backFormButtonText()
      updateUrls()
      updateSwatches()
    })
  })
}

const initNormalSwatches = () => {
  dom.normalSwatches.forEach((normalSwatch) => {
    normalSwatch.addEventListener('click', () => {
      dom.selectedVariant.value = normalSwatch.dataset.swatch
      state.selectedVariant = state.currentProduct.variants.filter(
        (variant) => variant.id == parseInt(dom.selectedVariant.value),
      )[0]
      dom.normalSwatches.forEach((swatch) => swatch.classList.toggle('swatch--active', normalSwatch == swatch))

      dom.price.innerHTML = money(state.selectedVariant.price)

      updateUrls()
    })
  })
}

const backFormButtonText = () => {
  if (dom.addToCart) {
    dom.addToCart.classList.remove('main-product--oos', 'main-product--oos__soldout')
    if (state.selectedVariant) {
      if (state.selectedVariant.comingSoon) {
        dom.addToCart.innerHTML = window.pdpStrings.comingSoonCTA || 'Coming Soon'
      } else if (
        typeof state.selectedVariant.metafields.leftonfriday.preorder_status != 'undefined' &&
        state.selectedVariant.metafields.leftonfriday.preorder_status &&
        state.selectedVariant.available
      ) {
        dom.addToCart.innerHTML = window.pdpStrings.preorder
      } else if (state.selectedVariant.available) {
        dom.addToCart.innerHTML = window.pdpStrings.addToCart
      } else {
        dom.addToCart.innerHTML =
          state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS
            ? window.pdpStrings.soldOut
            : window.pdpStrings.joinTheWaitlist
        dom.addToCart.classList.add('main-product--oos')
        dom.addToCart.classList.toggle(
          'main-product--oos__soldout',
          state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS,
        )
      }

      if (
        typeof state.selectedVariant.metafields.leftonfriday.preorder_status != 'undefined' &&
        state.selectedVariant.metafields.leftonfriday.preorder_status &&
        state.selectedVariant.metafields.leftonfriday.preorder_disclaimer_text &&
        state.selectedVariant.available
      ) {
        dom.preorderText.classList.remove('!hidden')
        dom.preorderText.innerHTML = state.selectedVariant.metafields.leftonfriday.preorder_disclaimer_text
      } else {
        dom.preorderText.classList.add('!hidden')
      }
    } else {
      dom.addToCart.innerHTML = state.currentProduct.available
        ? window.pdpStrings.addToCart
        : state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS
          ? window.pdpStrings.soldOut
          : window.pdpStrings.joinTheWaitlist
      dom.preorderText.classList.add('!hidden')
      dom.addToCart.classList.toggle('main-product--oos', !state.currentProduct.available)
      dom.addToCart.classList.toggle(
        'main-product--oos__soldout',
        !state.currentProduct.available &&
          (state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS),
      )
    }
    dom.thirdPayButtons.forEach((btn) =>
      btn.classList.toggle(
        '!hidden',
        dom.addToCart.innerHTML == window.pdpStrings.soldOut ||
          dom.addToCart.innerHTML == (window.pdpStrings.comingSoonCTA || 'Coming Soon'),
      ),
    )
  }
}

const initFormButton = () => {
  dom.addToCart.addEventListener('mouseenter', () => {
    if (!state.selectedVariant) {
      dom.addToCart.innerHTML = window.pdpStrings.selectSizeLong
      if (
        state.section.querySelector('.swatch--active.main-product--size__swatch') &&
        !state.section.querySelector('.swatch--active[data-swatch-additional]')
      ) {
        dom.addToCart.innerHTML = window.pdpStrings.selectSizeLong.replace('Size', state.currentProduct.options[2])
      }
    }
  })
  dom.addToCart.addEventListener('mouseleave', () => {
    backFormButtonText()
  })
  dom.addToCart.addEventListener('click', (e) => {
    e.stopPropagation()
    e.preventDefault()

    const giftCardForm = state.section.querySelector('[data-gift-card-form]')
    // Only validate gift card form if it's visible (not hidden)
    if (giftCardForm && !giftCardForm.classList.contains('hidden')) {
      const recipientName = giftCardForm.querySelector('input[name="properties[Recipient name]"]')
      const recipientEmail = giftCardForm.querySelector('input[name="properties[Recipient email]"]')
      const dateRadio = giftCardForm.querySelector('input[name="delivery-timing"][value="date"]')
      const dateInput = giftCardForm.querySelector('input[name="properties[Send on]"]')

      if (!recipientName.value.trim()) {
        recipientName.focus()
        return
      }

      if (!recipientEmail.value.trim() || !recipientEmail.validity.valid) {
        recipientEmail.focus()
        return
      }

      if (dateRadio?.checked && !dateInput?.value) {
        dateInput.focus()
        return
      }
    }

    if (state.selectedVariant) {
      if (state.selectedVariant.available) {
        dom.addToCart.setAttribute('disabled', '')

        // Collect properties from form inputs
        const properties = {}
        const formInputs = state.section.querySelectorAll('input[name^="properties["], textarea[name^="properties["]')
        formInputs.forEach((input) => {
          if (!input.disabled && input.value) {
            const match = input.name.match(/properties\[([^\]]+)\]/)
            if (match) {
              properties[match[1]] = input.value
            }
          }
        })
        const tagPart = state.currentProduct?.tags?.filter((tag) => tag.includes('takeoff'))[0]
        if (
          (!!state.selectedVariant?.comparePrice &&
            state.selectedVariant?.price < state.selectedVariant?.comparePrice) ||
          state.currentProduct?.finalSale === true
        ) {
          properties['_final_sale'] = 'true'
          properties['Note'] = 'Final Sale'
        }
        if (!!tagPart) {
          properties['_tag_part'] = tagPart
        }
        addLineItems(
          (cart) => {
            initMiniCart(cart)
            window.openCart()
            if (dom.addToCart.closest(`[${qs.popup}]`)) {
              // Close the Quick view
              toggleModal(false)
            }
            if (typeof window.learnqProductItem != 'undefined') {
              var _learnq = _learnq || []
              _learnq.push(['track', 'Added to Cart', window.learnqProductItem])
            }
          },
          [
            {
              id: state.selectedVariant.id,
              quantity: 1,
              properties,
            },
          ],
          dom.addToCart,
        )
      } else {
        if (state.selectedVariant.comingSoon) {
          toggleModal(true, document.querySelector('#product-coming-soon-popup').innerHTML, null, true)
          initComingSoon()
        } else if (!(state.currentProduct.disableBIS == 'true' || state.currentProduct.disableBIS)) {
          toggleModal(true, document.querySelector('#product-bis-popup').innerHTML, null, true)
          initBIS()
        }
      }
    }
  })
}

const initBIS = () => {
  // Klaviyo Back In Stock
  const bisSubmit = document.querySelector(`[${qs.popup}] [${qs.bisSubmit}]`)
  const bisEmail = document.querySelector(`[${qs.popup}] [${qs.bisEmail}]`)
  const bisErrorMsg = document.querySelector(`[${qs.popup}] [${qs.bisErrorMsg}]`)
  // const newsletterSubscribe = dom.popup.querySelector(`[${qs.newsletterSubscribe}]`)
  bisEmail.addEventListener('input', () => {
    bisErrorMsg.classList.add('hidden')
  })
  bisSubmit.addEventListener('click', () => {
    if (validateEmail(bisEmail.value.trim())) {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: bisEmail.value,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${state.selectedVariant.id}`,
              },
            },
          },
        },
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-05-15',
        },
        body: JSON.stringify(payload),
      }

      fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.klaviyoApiKey}`,
        requestOptions,
      )
        .then((result) => {
          console.log(result)
          bisErrorMsg.classList.remove('hidden')
          bisErrorMsg.innerHTML = window.bisStrings.success
        })
        .catch((error) => {
          console.log('error', error)
          bisErrorMsg.classList.remove('hidden')
          bisErrorMsg.innerHTML = window.bisStrings.error
        })

      const options = {
        method: 'POST',
        headers: { revision: '2024-07-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    properties: { SubscribeSource: 'Back In Stock Popup' },
                    email: bisEmail.value,
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: window.klaviyoListId } } },
          },
        }),
      }
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoApiKey}`, options)
        .then((response) => response.json())
        .then((response) => console.log(response))
        .catch((err) => console.error(err))
    } else {
      bisErrorMsg.classList.remove('hidden')
      bisErrorMsg.innerHTML = window.bisStrings.emailError
    }
  })
}

const initComingSoon = () => {
  // Klaviyo Back In Stock
  const csSubmit = document.querySelector(`[${qs.popup}] [${qs.csSubmit}]`)
  const csEmail = document.querySelector(`[${qs.popup}] [${qs.csEmail}]`)
  const csErrorMsg = document.querySelector(`[${qs.popup}] [${qs.csErrorMsg}]`)
  // const newsletterSubscribe = dom.popup.querySelector(`[${qs.newsletterSubscribe}]`)
  csEmail.addEventListener('input', () => {
    csErrorMsg.classList.add('hidden')
  })
  csSubmit.addEventListener('click', () => {
    if (validateEmail(csEmail.value.trim())) {
      let options = {
        method: 'POST',
        headers: { revision: '2024-07-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    properties: {
                      SubscribeSource: 'Coming Soon Popup',
                      ComingSoonVariantId: state.selectedVariant.id,
                    },
                    email: csEmail.value,
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: window.klaviyoComingSoonListId } } },
          },
        }),
      }
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoApiKey}`, options)
        .then((result) => {
          console.log(result)
          csErrorMsg.classList.remove('hidden')
          csErrorMsg.innerHTML = window.comingSoonStrings.success

          klaviyo.identify({
            email: csEmail.value,
          })
          klaviyo.track('Coming Soon', {
            VariantId: state.selectedVariant.id,
          })
        })
        .catch((error) => {
          console.log('error', error)
          csErrorMsg.classList.remove('hidden')
          csErrorMsg.innerHTML = window.comingSoonStrings.error
        })

      options = {
        method: 'POST',
        headers: { revision: '2024-07-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    properties: { SubscribeSource: 'Coming Soon Popup' },
                    email: csEmail.value,
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: window.klaviyoListId } } },
          },
        }),
      }
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${window.klaviyoApiKey}`, options)
        .then((response) => response.json())
        .then((response) => console.log(response))
        .catch((err) => console.error(err))
    } else {
      csErrorMsg.classList.remove('hidden')
      csErrorMsg.innerHTML = window.comingSoonStrings.emailError
    }
  })
}

const initSwiper = (reinit = false) => {
  if (window.innerWidth >= 1024) {
    if (state.swiper) {
      state.swiper.destroy(true, true)
      setTimeout(() => {
        state.swiper = null
      }, 200)
    }
  } else {
    if (reinit && state.swiper) {
      state.swiper.destroy(true, true)
      state.swiper = null
    }
    if (!state.swiper) {
      state.swiper = new Swiper(dom.images, {
        speed: 300,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      })
    }
  }

  state.videos.forEach((video) => {
    video.addEventListener('mouseenter', () => {
      video.play()
    })
    const videoFancyBox = video.closest('.main-product--video').querySelector(`[${qsAll.videoFancyBoxs}]`)
    videoFancyBox.addEventListener('mouseenter', () => {
      video.play()
    })
  })
}
const initProductImages = () => {
  Fancybox.bind('[data-fancybox="product-gallery"]', {
    Images: {
      initialSize: 'contain',
      Panzoom: {
        // minScale: 1.5,
      },
    },
    // on: {
    //   reveal: (fancybox, slide) => {
    //     setTimeout(() => {
    //       document.querySelectorAll('.fancybox__content').forEach(content => content.style.opacity = 1)
    //     }, 500)
    //     setTimeout(() => {
    //       document.querySelectorAll('.fancybox__content').forEach(content => content.style.opacity = 1)
    //     }, 1500)
    //   },
    // },
    Toolbar: {
      // items: {
      //   prev: {
      //     tpl: '<button class="f-button !fixed !top-1/2 !-translate-y-1/2 !left-3 lg:!left-6" title="{{PREV}}" data-fancybox-prev><svg class="!rotate-180 w-5 h-4" xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none"><path d="M0 4H14" stroke="currentColor" stroke-width="1.5"/><path d="M9 1L15 4L9 7" stroke="currentColor" stroke-width="1.5"/></svg></button>',
      //   },
      //   next: {
      //     tpl: '<button class="f-button !fixed !top-1/2 !-translate-y-1/2 !right-3 lg:!right-6" title="{{NEXT}}" data-fancybox-next><svg class="w-5 h-4" xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none"><path d="M0 4H14" stroke="currentColor" stroke-width="1.5"/><path d="M9 1L15 4L9 7" stroke="currentColor" stroke-width="1.5"/></svg></button>',
      //   },
      // },
      display: {
        left: [],
        middle: [
          // "zoomIn",
          // "zoomOut",
          // "toggle1to1",
          // "prev",
          // "next",
        ],
        right: ['close'],
      },
    },
    Thumbs: false,
  })
  initSwiper()
  window.addEventListener('resize', initSwiper)
}

const initShare = () => {
  dom.share.addEventListener('click', () => {
    console.log(dom.shareUrl.value)
    if (navigator.share) {
      navigator.share({ url: dom.shareUrl.value, title: document.title })
    } else {
      navigator.clipboard.writeText(dom.shareUrl.value).then(() => {
        dom.shareMessage.classList.add('!block')
        setTimeout(() => {
          dom.shareMessage.classList.remove('!block')
        }, 2000)
      })
    }
    if (typeof gtag != 'undefined') {
      gtag('event', 'share_click', {
        share_url: dom.shareUrl.value,
      })
    }
  })
}

const initGarment = (selector) => {
  const triggerButton = document.querySelector(selector)
  console.log('initGarment', triggerButton.dataset.src)
  const panel = document.querySelector(`.fancybox__container ${triggerButton.dataset.src}`)
  const garmentMobileTrigger = panel?.querySelector(`[${qs.garmentMobileTrigger}]`)
  const garmentTabs = Array.from(panel?.querySelectorAll(`[${qsAll.garmentTabs}]`))
  const activeGarmentTab = panel?.querySelector(`[${qs.activeGarmentTab}]`)
  const garmentContents = Array.from(panel?.querySelectorAll(`[${qsAll.garmentContents}]`))
  if (garmentMobileTrigger) {
    garmentMobileTrigger.addEventListener('click', () => {
      garmentMobileTrigger.querySelector('ul').classList.toggle('!grid')
    })
  }
  garmentTabs.forEach((garmentTab) => {
    garmentTab.addEventListener('click', (e) => {
      e.stopPropagation()
      activeGarmentTab.innerHTML = garmentTab.innerHTML.trim()
      garmentMobileTrigger.querySelector('ul').classList.remove('!grid')
      garmentTabs.forEach((tab) => {
        if (tab == garmentTab) {
          if (tab.tagName == 'BUTTON') {
            tab.classList.remove('text-black', 'hover:bg-black', 'hover:text-white')
            tab.classList.add('!bg-black', 'text-white')
          }
        } else {
          if (tab.tagName == 'BUTTON') {
            tab.classList.add('text-black', 'hover:bg-black', 'hover:text-white')
            tab.classList.remove('!bg-black', 'text-white')
          }
        }
      })
      garmentContents.forEach((garmentContent) => {
        const id = garmentTab.dataset.garmentChartTab
        const newId = garmentContent.dataset.garmentChartContent
        garmentContent.classList.toggle('!block', id == newId)
      })
    })
  })
}

const initFitGuide = (selector, type = 'selector') => {
  const options = {
    dragToClose: false,
    on: {
      ready: () => {
        setTimeout(() => {
          initGarment(selector)
        }, 100)
      },
      done: (fancybox, slide) => {
        console.log(fancybox)
        if (fancybox.container) {
          const images = fancybox.container.querySelectorAll('img')
          images.forEach((image) => {
            if (!image.hasAttribute('src')) image.src = image.dataset.src
          })
        }
      },
    },
  }
  if (type == 'selector') {
    Fancybox.bind(selector, options)
  } else {
    const triggerButton = document.querySelector(selector)
    triggerButton?.addEventListener('click', () => {
      new Fancybox(
        [
          {
            src: document.querySelector(triggerButton?.dataset?.wrap).innerHTML,
            type: 'html',
          },
        ],
        options,
      )
    })
  }
}
window.initFitGuide = initFitGuide

const seeFade = () => {
  Fancybox.bind('[data-fancybox="see-fade"]', {
    dragToClose: false,
    on: {},
  })
}

const setFisProductCardValues = (modalClone, product, variant) => {
  const productCard = modalClone.querySelector(`[${qs.fisProductCard}]`)
  if (!productCard) return

  const productImage = modalClone.querySelector(`[${qs.fisProductImage}]`)
  const productTitle = modalClone.querySelector(`[${qs.fisProductTitle}]`)
  const productPrice = modalClone.querySelector(`[${qs.fisProductPrice}]`)
  const productOptions = modalClone.querySelector(`[${qs.fisProductOptions}]`)

  if (productImage && product.featured_image) {
    productImage.src = product.featured_image.src || product.featured_image
    productImage.alt = product.title
  }

  if (productTitle) {
    productTitle.textContent = product.title
  }

  if (productPrice) {
    productPrice.textContent = money(variant.price)
  }

  if (productOptions && product.options && variant.options) {
    productOptions.innerHTML = ''
    product.options.forEach((optionName, index) => {
      if (variant.options[index]) {
        const optionEl = document.createElement('p')
        optionEl.innerHTML = `<span class='font-bold'>${optionName}:</span><span> ${variant.options[index]}</span>`
        productOptions.appendChild(optionEl)
      }
    })
  }
}

const isVariantInStock = (variant) => {
  const inventoryInfo = variant.metafields?.location_inventory_info || []

  // This is the Shopify location ids from the metaobject list set in the block settings.
  const fisStores = document.querySelector(`[${qs.fisStores}]`)?.dataset?.fisStores?.split(',').map(Number) || []
  let inStock = false

  inventoryInfo.forEach((info) => {
    if (info.quantity > 0 && fisStores.includes(info.location?.id)) {
      inStock = true
      return
    }
  })
  return inStock
}

const setFisStockStatus = (modalClone, inventoryInfo) => {
  const LOW_STOCK_THRESHOLD = 1
  const stockElements = modalClone.querySelectorAll(`[${qs.fisStock}]`)

  stockElements.forEach((stockEl) => {
    const locationId = stockEl.getAttribute(qs.fisStock)
    const inventoryData = inventoryInfo.find(
      (info) => String(info.loc) === String(locationId) || String(info.location?.id) === String(locationId),
    )

    const quantity = inventoryData?.quantity || 0
    const stockText = stockEl.querySelector(`[${qs.fisStockText}]`)
    const stockSvg = stockEl.querySelector('svg')

    stockSvg.classList.remove('text-[#0F9C0A]', 'text-[#ED8600]', 'text-[#C81D22]')
    if (quantity > LOW_STOCK_THRESHOLD) {
      stockSvg.classList.add('text-[#0F9C0A]')
      stockText.textContent = window.pdpStrings.inventoryInStock
    } else if (quantity > 0 && quantity <= LOW_STOCK_THRESHOLD) {
      stockSvg.classList.add('text-[#ED8600]')
      stockText.textContent = window.pdpStrings.inventoryLowStock
    } else {
      stockSvg.classList.add('text-[#C81D22]')
      stockText.textContent = window.pdpStrings.inventoryOutOfStock
    }
  })
}

const initFindInStore = () => {
  if (!dom.fisTrigger) return

  dom.fisTrigger.addEventListener('click', (e) => {
    e.preventDefault()
    const modalContent = document.querySelector(`[${qs.fisModal}]`)
    if (!modalContent) return
    const modalClone = modalContent.cloneNode(true)
    modalClone.classList.remove('hidden')

    if (state.selectedVariant && state.currentProduct) {
      setFisProductCardValues(modalClone, state.currentProduct, state.selectedVariant)

      const inventoryInfo = state.selectedVariant?.metafields?.location_inventory_info || []
      setFisStockStatus(modalClone, inventoryInfo)
    }

    toggleModal(true, modalClone.innerHTML, null, true, {
      wrapper: 'right-0 left-auto lg:max-w-xl h-full lg:max-h-full w-full',
      modal: 'justify-end',
      close: 'text-lof-dark-grey size-6',
    })
  })
}

const initGiftGuide = () => {
  Fancybox.bind('[data-fancybox][data-src="#gift-guide"]', {
    dragToClose: false,
  })
}

export const setupProduct = (sectionId) => {
  state.section = document.querySelector(`[data-section-id="${sectionId}"]`)
  cacheDom(dom, qs, qsAll, true, state.section)
  state.addons = document.querySelector(`[${qs.addons}]`)
  state.relatedProducts = document.querySelector(`[${qs.relatedProducts}]`)

  state.sizeSwatches = dom.sizeSwatches
  state.thirdSwatches = dom.thirdSwatches
  state.currentProduct = state.section.querySelector('.main-product--colour__swatch.swatch--active')
    ? JSON.parse(state.section.querySelector('.main-product--colour__swatch.swatch--active').dataset.colourSwatch)
    : state.section.querySelector('.main-product--normal__swatch.swatch--active')
      ? JSON.parse(state.section.querySelector('.main-product--normal__swatch.swatch--active').dataset.product)
      : null
  state.selectedVariant = state.section.querySelector('.main-product--normal__swatch.swatch--active')
    ? state.currentProduct.variants.filter(
        (variant) =>
          variant.id ==
          parseInt(state.section.querySelector('.main-product--normal__swatch.swatch--active').dataset.swatch),
      )[0]
    : null
  if (state.currentProduct && state.section.querySelector('.main-product--size__swatch.swatch--active')) {
    const variantId = state.section.querySelector('.main-product--size__swatch.swatch--active').dataset.sizeSwatch
    state.selectedVariant = state.currentProduct.variants.filter((variant) => variant.id == parseInt(variantId))[0]
  }
  state.selectedSizeValue = state.section.querySelector(`.swatch--active[data-size-swatch]`)?.dataset?.swatchValue
  state.selectedThirdValue = state.section.querySelector(
    `.swatch--active[${qsAll.thirdSwatches}]`,
  )?.dataset?.swatchValue
  state.videos = dom.videos

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    if (scrollTop == 0) {
      state.section.querySelector('.main-product--panel__wrapper').scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }
  })

  if (state.selectedVariant) {
    const fisContent = state.section.querySelector(`[${qs.fisContent}]`)
    if (isVariantInStock(state.selectedVariant)) {
      fisContent?.classList?.remove('hidden')
    } else {
      fisContent?.classList?.add('hidden')
    }
  }

  initProductImages()
  initColourSwatches()
  initSizeSwatches()
  initThirdSwatches()
  initNormalSwatches()
  updateSwatches()
  backFormButtonText()
  updateKlarnaStyles()
  seeFade()
  if (dom.addToCart) initFormButton()
  initShare()
  initFindInStore()
  initGiftGuide()
  initGiftCardForm()

  // Init fit guide popup
  initFitGuide('[data-fancybox="product-fit-guide--product"]')

  // Klaviyo events
  if (typeof window.learnqProductItem != 'undefined') {
    var _learnq = _learnq || []
    _learnq.push(['track', 'Viewed Product', window.learnqProductItem])
    _learnq.push([
      'trackViewedItem',
      {
        Title: window.learnqProductItem.Name,
        ItemId: window.learnqProductItem.ProductID,
        Categories: window.learnqProductItem.Categories,
        ImageUrl: window.learnqProductItem.ImageURL,
        Url: window.learnqProductItem.URL,
        Metadata: {
          Brand: window.learnqProductItem.Brand,
          Price: window.learnqProductItem.Price,
          CompareAtPrice: window.learnqProductItem.CompareAtPrice,
        },
      },
    ])
  }
  window.addEventListener('popstate', () => {
    if (location.pathname.includes('/products')) {
      const parts = location.pathname.split('/')
      const handle = parts[parts.length - 1]
      const swatch = dom.colourSwatches.filter((swatch) => swatch.getAttribute('data-handle') == handle)[0]
      if (swatch) swatch.dispatchEvent(new Event('click'))
    }
  })

  if (dom.form?.hasAttribute('data-product-form-custom')) {
    document.querySelector('.main-product--options').classList.add('main-product--options__overwrite')
  }
  // Open Insanely Comfortable Fit ™ Tab on load
  const insaneTab = document.querySelector('[data-slug*="insanely-comfortable-fit"]')
  insaneTab?.setAttribute('aria-expanded', 'true')
  insaneTab?.classList?.add('is-active')
  const insanePanel = document.querySelector(
    `.station-tabs-tabpanel[data-pro-tab-id="${insaneTab?.getAttribute('data-pro-tab-id')}"]`,
  )
  insanePanel?.classList?.add('is-active')
  insanePanel?.setAttribute('aria-hidden', 'false')
}
